// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 3H17V11H2V3ZM2 14H22V16H2V14ZM2 19H22V21H2V19Z"}}]};

const TypographyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'typography-filled',
    ref,
    icon: element,
  },
));

TypographyFilledIcon.displayName = 'TypographyFilledIcon';

export default TypographyFilledIcon;
